import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import RecommendationIcon from '@/svg-icons/recommendation';

const RecommendationSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <RecommendationIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="recommendation" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      <div className="w-full" data-cy="order-details-recommendation-code">
        <div className="font-bold">
          <FormattedMessage id="code" />
        </div>
        <span>{data.code}</span>
      </div>
    </div>
  </div>
);

RecommendationSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default RecommendationSection;
